import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const SurveySection = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  // TODO: 설문조사 완성 후 실제 링크로 교체
  const surveyLink = 'https://forms.gle/example'; // 구글 폼 링크 예시

  return (
    <section ref={sectionRef} className="survey-section scroll-reveal">
      <div className="involvement-card">
        <div className="involvement-icon">
          <FontAwesomeIcon icon={faClipboardList} />
        </div>
        <h3>{t('involvement.survey.title')}</h3>
        <p>{t('involvement.survey.description')}</p>
        <a href={surveyLink} target="_blank" rel="noopener noreferrer" className="involvement-btn">
          {t('involvement.survey.participate')}
        </a>
        <p className="note">{t('involvement.survey.note')}</p>
      </div>
    </section>
  );
};

export default SurveySection;
